export default __webpack_public_path__ + "static/media/bed_icon_b.42153964.svg";